import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import * as actionTypes from '@redux/actionTypes';
import { qos, rtc, rtm, localTracks, V4, V5, frontCamMediaStream, backCamMediaStream, microphoneMediaStream, checkAngularLevel } from '@util/robotControlData';
import { safeLocalStorage } from "@utils/localstorage";
import { getActiveGamepad } from "@utils/gamepad/getActiveGamepad";
import { getAgoraToken } from '@services/api';

const isBrowser = typeof window !== "undefined"
const user = safeLocalStorage.getItem('token')
const user_id = parseInt(user?.user?.id)
const APP_ID = process.env.NEXT_PUBLIC_AGORA_APP_ID
let loadedAllData = false
let lampOnOff = 0
let sppedTimeOut;
let _speed = 3
let initGp;
let pressedKeys = {
    'w': false,
    'a': false,
    's': false,
    'd': false,
};
let robotLinerData = { 'angular': -0, 'linear': -0, 'lamp': 0 };
// Lazy-loaded to avoid module-eval-time require of UMD-wrapped SDKs, which
// crashes the Next.js prod bundle with "TypeError: r is not a function" —
// webpack's runtime helper isn't ready when these requires run at top level.
let AgoraRTM = null;
let AgoraRTC = null;
const ensureAgoraSdks = () => {
    if (!isBrowser) return;
    if (!AgoraRTM) AgoraRTM = require('agora-rtm-sdk');
    if (!AgoraRTC) AgoraRTC = require('agora-rtc-sdk-ng');
};
let deviceId = "";
const tournamentData = safeLocalStorage.getItem('tournamentData')
if (isBrowser) {
    deviceId = tournamentData?.deviceId;
    if (!deviceId) {
        deviceId = tournamentData?.deviceId;
    }
    if (!deviceId) {
        deviceId = tournamentData?.deviceId;
    }
    if (!deviceId) {
        deviceId = tournamentData?.deviceId;
    }
}

let controlConfig = V5

const gamepadPolling = (sendGamepadData, controlConfig) => {
    const keyboradKey = safeLocalStorage.getItem(`keyboradKey`)
    const wheelKey = safeLocalStorage.getItem(`WheelKey`)
    const user_id = parseInt(user?.user?.id)
    const keyBinding = safeLocalStorage.getItem(`keyBinding_${user_id}`)
    if (rtc.client && rtm.client && rtm.client.connectionState === 'CONNECTED') {
        if (keyboradKey) {
            // keyboard control
            window.addEventListener('keydown', handleKeyDown);
            window.addEventListener('keyup', handleKeyUp);
            handleAnotherKeyDown(keyBinding, controlConfig)
        } else {
            //  default linear data
            let linear = { 'x': 0.0, 'y': 0.0, 'z': 0.0 };
            //  default angular data
            let angular = { 'x': 0.0, 'y': 0.0, 'z': 0.0 };
            //  default baselevel value
            let gamepadBaseLevel = 0.05;

            // Gamepad data
            const gp = getActiveGamepad();

            // default speed is 3
            let speed = controlConfig.speed3[0];
            // default angularCoef value
            let angularCoef = controlConfig.speed3[1];
            // default angularBias value
            let angularBias = controlConfig.speed3[2];

            if (gp) {
                // Added setTimeout for remove multi key press on single press , only for speed up/down and Toggle buttons
                if (gp.buttons[keyBinding[`Shift Up Speed`]].pressed && _speed < 5) {
                    clearTimeout(sppedTimeOut)
                    sppedTimeOut = setTimeout(() => {
                        _speed = _speed + 1
                    }, 200)
                } else if (gp.buttons[keyBinding[`Shift Down Speed`]].pressed && _speed > 1) {
                    clearTimeout(sppedTimeOut)
                    sppedTimeOut = setTimeout(() => {
                        _speed = _speed - 1
                    }, 200)
                }

                // Gear shift store on speed 
                if (_speed > 0 && _speed <= 5) {
                    speed = controlConfig[`speed${_speed}`][0]
                    angularBias = controlConfig[`speed${_speed}`][2];
                }

                let accelerateKey = `Accelerate/Reverse`

                // combine wheelKey for Pedal/Reverse Input, becasue some controler have same key for both inputs 
                if (wheelKey) {
                    accelerateKey = `Accelerate Input`
                    const pedalInput = gp.axes[keyBinding[`Accelerate Input`][`key`]] * (keyBinding[`Accelerate Input`][`Inverted Axis`] ? -1 : 1)
                    const brakeInput = gp.axes[keyBinding[`Reverse Input`][`key`]] * (keyBinding[`Reverse Input`][`Inverted Axis`] ? -1 : 1)

                    const pedalInputData = keyBinding[`Accelerate Input`]['Centered Axis'] ? (pedalInput / 2) + 0.5 : pedalInput
                    const brakeInputData = keyBinding[`Reverse Input`]['Centered Axis'] ? (brakeInput / 2) + 0.5 : brakeInput
                    const axisDefault = initGp[keyBinding[`Reverse Input`][`key`]];
                    if (Math.abs(axisDefault - gp.axes[keyBinding[`Reverse Input`][`key`]]) >= 0.01) {
                        if (Math.abs(pedalInputData) < Math.abs(brakeInputData)) {
                            accelerateKey = `Reverse Input`
                        }
                    }
                }

                // store pressed key data values to variables 
                let accelerateData = gp.axes[keyBinding[accelerateKey][`key`]]
                let angularData = gp.axes[keyBinding[`Steer Left/Right`][`key`]]

                // logic for convert keys data to Centered and Inverted base on user preferences 
                const isCenteredLinear = keyBinding[accelerateKey]['Centered Axis']
                const isCenteredAngular = keyBinding['Steer Left/Right']['Centered Axis']
                const invertedLinear = keyBinding[accelerateKey][`Inverted Axis`] ? -1 : 1
                const invertedAngular = keyBinding[`Steer Left/Right`][`Inverted Axis`] ? 1 : -1
                const axisEasingLinear = (keyBinding[accelerateKey]['AxisEasing'] || 0) / 100
                const axisEasingAngular = (keyBinding['Steer Left/Right']['AxisEasing'] || 0) / 100
                const deadZoneRest = keyBinding['Steer Left/Right']['deadZoneRest']

                // Update Linear data base on Centered and inverted 
                accelerateData = isCenteredLinear ? (accelerateData * invertedLinear / 2) + 0.5 : accelerateData * invertedLinear;

                // Update AxisEasing
                if (wheelKey) {
                    accelerateData = axisEasingLinear * (accelerateData * accelerateData * accelerateData) + ((1 - axisEasingLinear) * accelerateData)
                }

                // Update angular data base on Centered and inverted 
                angularData = isCenteredAngular ? (angularData * invertedAngular / 2) + 0.5 : angularData * invertedAngular;

                // Update angular data for deadZone and axisEasing
                if (wheelKey) {
                    angularData = axisEasingAngular * (angularData * angularData * angularData) + ((1 - axisEasingAngular) * angularData)
                    angularData = (deadZoneRest || 1) * angularData
                }

                // Remove remote noise from controller default values 
                linear = (Math.abs(accelerateData) < gamepadBaseLevel) ? 0.0 : accelerateData * speed;
                angular = (Math.abs(angularData) < gamepadBaseLevel) ? 0.0 : angularData;

                // get angularCoef
                angularCoef = checkAngularLevel(controlConfig, Math.abs(linear));

                // Updated angular data if linear not zero --> turn bot while moving
                if (Math.abs(linear) > gamepadBaseLevel) {
                    angular = angular * linear * angularCoef * (linear > 0 ? 1.0 : -1.0);
                    angular = angular + angularBias;
                } else if (angular != 0) {
                    // Updated angular data with speed --> turn bot at spot
                    angular = angular * speed;
                }

                // Make sure Brake input alease have negative value 
                if (accelerateKey === `Reverse Input` && linear > 0) {
                    linear = linear * -1;
                }
                const speedMeasureElement = document.getElementById(`speedMeasure`)
                if (speedMeasureElement) {
                    speedMeasureElement.innerHTML = _speed
                }
            }

            const data = { 'angular': angular, 'linear': linear, 'lamp': lampOnOff };
            // send data to agora
            sendGamepadData(data);
        }
    }
    setTimeout(() => { gamepadPolling(sendGamepadData, controlConfig) }, 100);
};

const handleAnotherKeyDown = (keyBinding, controlConfig) => {
    const headlight = safeLocalStorage.getItem('headlight')
    if (pressedKeys[keyBinding[`Shift Up Speed`]] && _speed < 5) {
        clearTimeout(sppedTimeOut)
        sppedTimeOut = setTimeout(() => {
            _speed = _speed + 1
        }, 200)
    } else if (pressedKeys[keyBinding[`Shift Down Speed`]] && _speed > 1) {
        clearTimeout(sppedTimeOut)
        sppedTimeOut = setTimeout(() => {
            _speed = _speed - 1
        }, 200)
    } else if (pressedKeys[keyBinding[`Toggle Headlights`]]) {
        robotLinerData = { 'angular': 0, 'linear': 0, 'lamp': headlight === 'true' ? 100 : 0 };
        sendRtmMessage(robotLinerData)
    } else if (pressedKeys[keyBinding[`Drive Forwards`]] && pressedKeys[' '] && pressedKeys[keyBinding[`Drive Left`]]) {
        robotLinerData = { 'angular': 0.13999999999999999, 'linear': controlConfig[`speed${_speed}`][0], 'lamp': headlight === 'true' ? 100 : 0 };
        sendRtmMessage(robotLinerData)
    } else if (pressedKeys[keyBinding[`Drive Forwards`]] && pressedKeys[' '] && pressedKeys[keyBinding[`Drive Right`]]) {
        robotLinerData = { 'angular': -0.13999999999999999, 'linear': controlConfig[`speed${_speed}`][0], 'lamp': headlight === 'true' ? 100 : 0 };
        sendRtmMessage(robotLinerData)
    } else if (pressedKeys[keyBinding[`Drive Backwards`]] && pressedKeys[' '] && pressedKeys[keyBinding[`Drive Left`]]) {
        robotLinerData = { 'angular': 0.13999999999999999, 'linear': (-1 * controlConfig[`speed${_speed}`][0]), 'lamp': headlight === 'true' ? 100 : 0 };
        sendRtmMessage(robotLinerData)
    } else if (pressedKeys[keyBinding[`Drive Backwards`]] && pressedKeys[' '] && pressedKeys[keyBinding[`Drive Right`]]) {
        robotLinerData = { 'angular': -0.13999999999999999, 'linear': (-1 * controlConfig[`speed${_speed}`][0]), 'lamp': headlight === 'true' ? 100 : 0 };
        sendRtmMessage(robotLinerData)
    } else if (pressedKeys[keyBinding[`Drive Forwards`]] && pressedKeys[' ']) {
        robotLinerData = { 'angular': 0, 'linear': controlConfig[`speed${_speed}`][0], 'lamp': headlight === 'true' ? 100 : 0 };
        sendRtmMessage(robotLinerData)
    } else if (pressedKeys[keyBinding[`Drive Backwards`]] && pressedKeys[' ']) {
        robotLinerData = { 'angular': 0, 'linear': (-1 * controlConfig[`speed${_speed}`][0]), 'lamp': headlight === 'true' ? 100 : 0 };
        sendRtmMessage(robotLinerData)
    } else if (pressedKeys[keyBinding[`Drive Forwards`]] && pressedKeys[keyBinding[`Drive Left`]]) {
        robotLinerData = { 'angular': 0.27, 'linear': controlConfig[`speed${_speed}`][0], 'lamp': headlight === 'true' ? 100 : 0 };
        sendRtmMessage(robotLinerData)
    } else if (pressedKeys[keyBinding[`Drive Forwards`]] && pressedKeys[keyBinding[`Drive Right`]]) {
        robotLinerData = { 'angular': -0.27, 'linear': controlConfig[`speed${_speed}`][0], 'lamp': headlight === 'true' ? 100 : 0 };
        sendRtmMessage(robotLinerData)
    } else if (pressedKeys[keyBinding[`Drive Backwards`]] && pressedKeys[keyBinding[`Drive Left`]]) {
        robotLinerData = { 'angular': 0.27, 'linear': (-1 * controlConfig[`speed${_speed}`][0]), 'lamp': headlight === 'true' ? 100 : 0 };
        sendRtmMessage(robotLinerData)
    } else if (pressedKeys[keyBinding[`Drive Backwards`]] && pressedKeys[keyBinding[`Drive Right`]]) {
        robotLinerData = { 'angular': -0.27, 'linear': (-1 * controlConfig[`speed${_speed}`][0]), 'lamp': headlight === 'true' ? 100 : 0 };
        sendRtmMessage(robotLinerData)
    } else if (pressedKeys[keyBinding[`Drive Forwards`]]) {
        robotLinerData = { 'angular': 0, 'linear': controlConfig[`speed${_speed}`][0], 'lamp': headlight === 'true' ? 100 : 0 };
        sendRtmMessage(robotLinerData)
    } else if (pressedKeys[keyBinding[`Drive Backwards`]]) {
        robotLinerData = { 'angular': 0, 'linear': (-1 * controlConfig[`speed${_speed}`][0]), 'lamp': headlight === 'true' ? 100 : 0 };
        sendRtmMessage(robotLinerData)
    } else if (pressedKeys[keyBinding[`Drive Left`]]) {
        robotLinerData = { 'angular': 0.45, 'linear': 0, 'lamp': headlight === 'true' ? 100 : 0 };
        sendRtmMessage(robotLinerData)
    } else if (pressedKeys[keyBinding[`Drive Right`]]) {
        robotLinerData = { 'angular': -0.45, 'linear': 0, 'lamp': headlight === 'true' ? 100 : 0 };
        sendRtmMessage(robotLinerData)
    } else {
        robotLinerData = { 'angular': -0, 'linear': -0, 'lamp': headlight === 'true' ? 100 : 0 };
        sendRtmMessage(robotLinerData)
    }
    const speedMeasureElement = document.getElementById(`speedMeasure`)
    if (speedMeasureElement) {
        speedMeasureElement.innerHTML = _speed
    }
}

const handleKeyDown = (event) => {
    pressedKeys[event.key] = true;
};

const handleKeyUp = (event) => {
    pressedKeys[event.key] = false;
};

const agoraEnableAudio = async (state) => {
    if (!localTracks.audioTrack) return false;
    await localTracks.audioTrack.setMuted(!state);
    return state;
}

const sendRtmMessage = async (data) => {
    if (rtm && rtm.client) {
        await rtm.client.queryPeersOnlineStatus([rtm.peerId]).then((res) => {
            if (res[rtm.peerId])
                rtm.client.sendMessageToPeer({ 'text': JSON.stringify(data) }, rtm.peerId)
        });
    }
}

const agoraDriving = async (onAgoraOpen, channel, rtcToken, rtmToken, media, newChannel, newUid) => {

    const options = {
        appId: APP_ID,
        channel: newChannel, // channel,
        rtcToken: rtcToken,
        rtmToken: rtmToken,
        driverUid: '' + newUid //channel + '-driver',
    };

    if (isBrowser) {
        rtc.client = AgoraRTC.createClient({ mode: "live", codec: "h264" });
        rtc.client.setClientRole('host');
    }
    // if (waitingSeconds >= 0) {
    //     setTimeout(() => {
    //         waitingSeconds = waitingSeconds > 0 ? waitingSeconds - 1 : 0
    //     }, 1000);
    // }

    rtc.client.on("user-published", async (user, mediaType) => {
        await rtc.client.subscribe(user, mediaType);
        if (mediaType == "video" && user.uid == 1000) {
            const el = document.getElementById(media['front-cam']);
            const stat = user.videoTrack.getCurrentFrameData();
            frontCamMediaStream.addTrack(user.videoTrack._mediaStreamTrack);
            if (el) {
                el.srcObject = frontCamMediaStream;
                el.autoplay = true;
                el.muted = true;
                // hideLoadingScreen('testdrive-loading-screen');
            }
            //  else {
            //     handleReload();
            // }
        }
        else if (mediaType == "video") {
            const el = document.getElementById(media['back-cam']);
            backCamMediaStream.addTrack(user.videoTrack._mediaStreamTrack);
            if (el) {
                el.srcObject = backCamMediaStream
                el.autoplay = true;
                el.muted = true
            }
        }
        else if (mediaType == "audio") {
            const el = document.getElementById(media['microphone']);
            microphoneMediaStream.addTrack(user.audioTrack._mediaStreamTrack);
            if (el) {
                el.srcObject = microphoneMediaStream;
                el.autoplay = true;
                el.controls = true;
                el.muted = true;
            }
        }
    });

    const uid = await rtc.client.join(options.appId, options.channel, options.rtcToken, user_id);

    await loginRtm(deviceId, options, onAgoraOpen)

    if (isBrowser) {
        try {
            localTracks.audioTrack = await AgoraRTC.createMicrophoneAudioTrack();
            rtc.client.publish(Object.values(localTracks));
            audioStatus = agoraEnableAudio(false)
        } catch (error) {
            console.warn('Microphone unavailable, continuing without audio publish:', error?.message || error);
        }
    }
}

const loginRtm = async (deviceId, options, onAgoraOpen) => {
    try {
        if (rtm.client && rtm.client.connectionState === 'CONNECTED') {
            console.log('rtm.client:', 'RTM client is already logged in.');
            return;
        }

        rtm.peerId = deviceId;
        rtm.client = AgoraRTM.createInstance(options.appId)

        rtm.client.on('MessageFromPeer', function (message, peerId) {
            const controls = JSON.parse(new TextDecoder().decode(message.rawMessage))
            const event = new CustomEvent("message-from-peer", { detail: controls });
            document.dispatchEvent(event);
        });

        // RTM token shares the same 15-min TTL as the RTC token but the RTM SDK
        // never renews itself. Because drive controls + battery/map telemetry all
        // ride on RTM, letting it lapse takes them all down mid-ride. Renew on
        // expiry to keep the control + telemetry channel alive.
        rtm.client.on('TokenExpired', async () => {
            console.log('RTM token expired - renewing...');
            try {
                const agoraToken = await getAgoraToken(deviceId);
                if (agoraToken && agoraToken.rtm_token) {
                    await rtm.client.renewToken(agoraToken.rtm_token);
                    options.rtmToken = agoraToken.rtm_token;
                    console.log('RTM token renewed successfully');
                } else {
                    console.error('RTM token renewal - received invalid token');
                }
            } catch (error) {
                console.error('RTM token renewal failed:', error);
            }
        });

        await rtm.client.login({ uid: options.driverUid, token: options.rtmToken }).then(() => {
            const channel = rtm.client.createChannel(options.channel);
            channel.join();
            onAgoraOpen();
        });
    } catch (error) {
        console.error('Failed to login RTM:', error);
    }
}

if (tournamentData?.speed_control_profile) {
    controlConfig = tournamentData?.speed_control_profile
    console.log('tournamentData?.speed_control_profile: ', tournamentData?.speed_control_profile);
} else if (Math.floor(parseInt(tournamentData?.hardware_version)) === 5) {
    controlConfig = V5;
} else if (Math.floor(parseInt(tournamentData?.hardware_version)) === 4) {
    controlConfig = V4;
} else {
    controlConfig = V4;
}

const onAgoraOpen = () => {
    gamepadPolling(sendRtmMessage, controlConfig);
}

const agora = async (rtm_token, rtc_token, newChannel, newUid) => {
    try {
        ensureAgoraSdks();
        let media = {}
        media['front-cam'] = 'front-cam';
        media['back-cam'] = 'back-cam';
        media['microphone'] = 'microphone';

        const tournamentData = safeLocalStorage.getItem('tournamentData')
        if (tournamentData && tournamentData?.deviceId && rtc_token && rtm_token && newChannel && newUid) {
            agoraDriving(onAgoraOpen, tournamentData?.deviceId, rtc_token, rtm_token, media, newChannel, newUid);
        }

        const el = document.getElementById('media-control')
        if (el) {
            el.style.display = 'block';
        }
    } catch (error) {
        console.log('error: ', error);
    }
}

let audioStatus = false;

export const mute = async (muted) => {
    audioStatus = await agoraEnableAudio(muted);
    return audioStatus
}

const RobotSendData = () => {
    const dispatch = useDispatch();
    const tournamentData = safeLocalStorage.getItem('tournamentData')
    const agoraTokenLocalStoarage = safeLocalStorage.getItem(`agoratoken_${tournamentData?.deviceId}`)
    deviceId = tournamentData?.deviceId ? tournamentData?.deviceId : deviceId
    const headLight = useSelector((state) => state?.sound?.headlight)
    const createRide = useSelector((state) => state.missionDetail.createRide)
    const newChannel = agoraTokenLocalStoarage?.channel || createRide?.agora?.channel
    const newUid = agoraTokenLocalStoarage?.uid || createRide?.agora?.uid
    const rtm_token = agoraTokenLocalStoarage?.rtm_token || createRide?.agora?.rtm_token
    const rtc_token = agoraTokenLocalStoarage?.rtc_token || createRide?.agora?.rtc_token

    useEffect(() => {
        const _messageFromPeer = function (e) {
            if (e.detail) {
                dispatch({
                    type: actionTypes.ROBOTDATA_DETAILS,
                    payload: e.detail
                })
            }
        }
        document.addEventListener("message-from-peer", _messageFromPeer);
        return async () => {
            document.removeEventListener('message-from-peer', _messageFromPeer)
            await logoutRtc()
            await unsubscribe()
            await logoutRtm();
        }
    }, [])

    useEffect(() => {
        if (!loadedAllData && rtm_token && rtc_token && newChannel && newUid) {
            loadedAllData = true
            agora(rtm_token, rtc_token, newChannel, newUid);
            let _interval = setInterval(() => {
                const gp = getActiveGamepad();
                if (gp?.axes?.length) {
                    initGp = gp.axes;
                    clearInterval(_interval)
                }
            }, 100)
        }
    }, [createRide, agoraTokenLocalStoarage])

    useEffect(() => {
        lampOnOff = headLight ? 100 : 0
        const _headLight = { 'angular': 0, 'linear': 0, 'lamp': lampOnOff };
        sendRtmMessage(_headLight)
    }, [headLight])

    useEffect(() => {
        if ('getGamepads' in navigator) {
            window.addEventListener('gamepaddisconnected', function (event) {
                const gamepad = event.gamepad;
                const remoteDisconnected = { 'angular': -0, 'linear': -0, 'lamp': 0 };
                sendRtmMessage(remoteDisconnected)
            });
        } else {
            console.log('Gamepad API not supported');
        }
    })

    const logoutRtc = async () => {
        if (rtc.client) {
            await rtc.client.leave();
            rtc.client = null;
            rtc.localAudioTrack = null;
            rtc.localVideoTrack = null;
        }
    }

    const logoutRtm = async () => {
        try {
            if (rtm.client && rtm.client.connectionState === 'CONNECTED') {
                await rtm.client.logout();
                rtm.client = null;
                rtm.peerId = '';
                console.log('RTM logout successful');
            } else {
                console.log('RTM client is not logged in.');
            }
        } catch (error) {
            console.error('Failed to logout RTM:', error);
        }
    };

    const unsubscribe = async () => {
        try {
            await rtm.client.unsubscribe(newChannel);
        } catch (error) {
            console.log("error", error);
        }
    };

    return (
        <div>
            <audio id="microphone" />
            <div className="container-fluid">
                <div id="media-control" >
                    <button onClick={mute} id="mute" type="button" className="btn btn-light"> Mute</button>
                </div>
            </div>
        </div>
    )
}

export default RobotSendData;
